import { BankMaster } from "./BindMdl";
import { mdlCancellation_Reason_Master } from "./mdlCancellation_Reason_Master";

export class mdlBindInfo_MotorCancel_Res {

    public RegNo: string;
    public PolicyNo: string;
    public InsuredIdNo: string;
    public InsuredName_En: string;
    public InsuredName_Ar: string;
    public TotalPremium: number;
    public RefundAmountExcVat: number;
    public VatOnRefundAmount: number;
    public RefundAmount: number;
    public MobileNo: string;
    public IBANNo: string;
    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;
    public Bankname: string;
    public CancellationReason: number;
    public bankList: Array<BankMaster> = new Array<BankMaster>();
    public CancellationReasonList: Array<mdlCancellation_Reason_Master> = new Array<mdlCancellation_Reason_Master>();
    public VehicleDefType: string;
    public VehicleId: string;
    public CustomIssuenceDate: string;
    public PlateNo: string;
    public PlateTextAr: string;
    public PlateTextEng: string;
    public ChassisNo: string;
    public StatusCode: string;
    public StatusDescEng: string;
    public StatusDescAr: string;
    public Lng: string;
    public UsedDays: number;
    public RemainingDays: number;


    public AttachmentId:string;
    public IDCopyImage: string;
    public IBANCopyImage: string;
    public AltInsuranceCopyImage: string;
    public NewOwnerIsthCopyImage: string;
    public ProofOfVehDisposeCopyImage: string;

    public IDCopyName: string;
    public IBANCopyName: string;
    public AltInsuranceCopyName: string;
    public NewOwnerIsthCopyName: string;
    public ProofOfVehDisposeCopyName: string;

 
    public IDCopyExists: boolean;
    public IBANCopyExists: boolean;
    public AltInsuranceCopyExists: boolean;
    public NewOwnerIsthCopyExists: boolean;
    public ProofOfVehDisposeCopyExists: boolean;

    public Vehicle_ManfYear:number;
    public Vehicle_CustomId: string;
    public Insured_nationality: string;
    public Insured_DOB: string;
 
    public AccountName: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfo_MotorCancel_Res.ts